//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import bottom from '@/assets/img/bottom.png'

export default {
  name: "sendOrderRowAdd",
  components: {
    footerNav
  },
  computed: {
  },
  data() {
    return {
      bottom,
      number:'',
      checkAll:false,
      type:1,
      result:[],
      show:false,
      value:'',
      list:[
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:1,sendNumber:''},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:2,sendNumber:''},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:3,sendNumber:''},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:4,sendNumber:''},
        ]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.color = value;
      this.showPicker = false;
    },
    next(){
      var arr = [];
      this.list.forEach(e => {
        if (e.choose) {
          arr.push(e)
        }
      });
      this.$router.push({name: 'sendOrderAdd', params: {arr:arr}})
    },
    chooseAll(){
      let a = this.checkAll;
      this.list = this.list.map(e => {
        e.choose = a;
        return e;
      });
    },
    // checkboxChange(i,$event){
    //   this.type=1;
    //   this.selectRow = i
    //   if($event){
    //     this.show = true;
    //   }
    // },
    choose() {
      let a = true;
      this.list.forEach(e => {
        if (e.choose === false) {
          a = false;
        }
      });
      console.log(a)
      this.checkAll = a;
    },

    onSearch(){

    },
    chooseConfirm(){

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/rowAdd.vue